<div class="container-fluid">
  <ul>
    <li>
      <a href="http://www.failteireland.ie" target="_blank" aria-label="Fáilte Ireland Logo">
        <!-- <span class="icon-logo" matTooltip="Fáilte Ireland Website"></span> -->
        <img class="icon-logo" src="https://cdn.failteireland.ie/brandsassets/logos/FI_Mark_RGB_Primary_Black.png"
          matTooltip="Fáilte Ireland Website" />
      </a>
    </li>
  </ul>
</div>